module.exports = __webpack_public_path__ + "media/images/nita-15015d6195ca0f8ce23857e955a5eaf5.png";